import Vue from "vue"

export default {
    addToJobsDisplayList(state, job) {
        let currentUploadingIndex = state.allJobsStatusList.findIndex(el => el.job_id === job.message.job_id);
        if (currentUploadingIndex === -1) {
            state.allJobsStatusList.push(job.message);
        } else {
            Vue.set(state.allJobsStatusList, currentUploadingIndex, job.message);
        }
    },
};